module.exports = __webpack_public_path__ + "static/img/refrigerated-delivery.c6a98be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/track/1/refrigerated-delivery.png
// module id = cDKI
// module chunks = 1